import { faArrowRightArrowLeft, faBuildingColumns, faCashRegister, faVault } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import cn from 'classnames';
import { getEntityLink } from 'helpers/getEntityLink';
import { CASHBOX_TYPES } from 'constants/cashboxTypes';
import { MoneyAmount } from 'components/MoneyAmount';
import { Button } from 'components/Button';
import { Actions } from '../Actions';
import styles from './CashboxCard.scss';

export const CashboxCard = ({ cashbox, handleTransferOpen, setEditingCashbox, setPaymentMethodsCashbox, index }) => {
  const isLocationType = cashbox.type === CASHBOX_TYPES.SAFE || cashbox.type === CASHBOX_TYPES.REGISTER;
  const animationDelay = index * 100;

  const [delayedBalance, setDelayedBalance] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      setDelayedBalance(cashbox.balance);
    }, animationDelay);

    return () => clearTimeout(timer);
  }, [cashbox.balance]);

  const getCashboxIcon = (type) => {
    if (type === CASHBOX_TYPES.ACCOUNT) return faBuildingColumns;
    if (type === CASHBOX_TYPES.SAFE) return faVault;
    if (type === CASHBOX_TYPES.REGISTER) return faCashRegister;
  };

  const getCashboxDescription = (type) => {
    if (type === CASHBOX_TYPES.ACCOUNT) return 'рахунку';
    if (type === CASHBOX_TYPES.SAFE) return 'сейфу';
    if (type === CASHBOX_TYPES.REGISTER) return 'каси';
  };

  return (
    <div
      key={cashbox.id}
      className={cn(styles.card, {
        [styles.accountCard]: !isLocationType,
        [styles.locationCard]: isLocationType,
      })}
      onClick={() => navigate(getEntityLink(`finance/${cashbox.id}`))}
    >
      <div className={styles.header}>
        <div className={styles.info}>
          <div className={styles.icon}>
            <FontAwesomeIcon icon={getCashboxIcon(cashbox.type)} />
          </div>
          <h3 className={styles.title}>{isLocationType ? cashbox.location?.name : cashbox.name}</h3>
        </div>
        <div className={styles.actions}>
          <Button
            className={styles.actionBtn}
            onClick={(e) => handleTransferOpen(e, cashbox)}
            title={`Швидкий переказ з ${getCashboxDescription(cashbox.type)}`}
            noStyle
          >
            <FontAwesomeIcon icon={faArrowRightArrowLeft} />
          </Button>
          {cashbox.type === CASHBOX_TYPES.ACCOUNT && (
            <Actions
              className={cn(styles.actionBtn, styles.other)}
              cashbox={cashbox}
              setEditingCashbox={setEditingCashbox}
              setPaymentMethodsCashbox={setPaymentMethodsCashbox}
            />
          )}
        </div>
      </div>

      <div className={styles.additionalInfo}>
        {!!cashbox.methods.length && (
          <div className={styles.additionalInfoColumn}>
            <span className={styles.methodsTitle}>
              {cashbox.type === CASHBOX_TYPES.ACCOUNT ? 'Коротка назва' : 'Спосіб поповнення'}:
            </span>{' '}
            <p className={styles.methods}>{cashbox.methods.find((m) => m.type === 'basic')?.label}</p>
          </div>
        )}

        {cashbox.methods.some((m) => m.type === 'additional') && (
          <div className={styles.additionalInfoColumn}>
            <span className={styles.methodsTitle}>Способи поповнення:</span>{' '}
            <p className={styles.methods}>
              {cashbox.methods
                .filter((m) => m.type === 'additional')
                .map((m) => m.label)
                .join(', ')}
            </p>
          </div>
        )}
      </div>

      <div className={styles.balance}>
        <p className={styles.amount}>
          <MoneyAmount value={delayedBalance} />
        </p>
        <p className={styles.label}>Доступно</p>
      </div>
    </div>
  );
};
